import { AboutComponent2 } from '../../components/core/AboutComponent2'
import { ContactComponent } from '../../components/core/ContactComponent'
import HeroComponent2 from '../../components/core/HeroComponent2'
import { PortfolioComponent2 } from '../../components/core/PortfolioComponent2'
import { ServicesComponent2 } from '../../components/core/ServicesComponent2'
import TestimonialsComponent2 from '../../components/core/TestimonialsComponent2'

export function HomePage2() {
  return (
    <div className="min-h-screen bg-background">
      <HeroComponent2 />
      <ServicesComponent2 />
      <AboutComponent2 />
      <PortfolioComponent2 />
      <TestimonialsComponent2 />
      {/* <PricingComponent2 /> */}
      <ContactComponent />
    </div>
  )
}
